import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CreateCertificate {

    public file: FileMetaDTO | null = null;
    public holder: string | null = null;

}
